import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../web.common';
import AriaModal from 'react-aria-modal';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayPrice,
  DisplayDate,
  DisplayGuid,
  DisplayStatus,
  DisplayPaymentMethod
} from '../items';
import { DetailsRightBar, NoLink, Divider, Action } from './DetailsRightBar';
import { transactionStatus } from '../../enums/transactionStatus';

const configReader = require('../../config');

class TransactionInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { transactionId } } } = this.props;
    const { api: { transactions: { getTransaction } } } = this.props;

    try {
      const transactionData = await getTransaction(transactionId);
      this.setState({ transactionData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { transactionId } } } = this.props;
    const { transactionData, errorMessage, isConfirmingCancellation } = this.state;
    const { adyen } = configReader.get();

    let mappedData = null;

    if (transactionData) {
      const {
        Id,
        CreatedAtCet,
        SettleAtCet,
        PaymentMethod,
        SubscriptionId,
        PurchaseId,
        ErrorText = '',
        Price,
        Status,
        ExternalReference = '',
        ExternalReferenceOriginal = ''
      } = transactionData;

      const adyenLink = `https://${adyen.domain}/ca/ca/accounts/showTx.shtml?`
      + `txType=Payment&pspReference=${Status === 'Refund' ? ExternalReferenceOriginal : ExternalReference}`;

      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        Price: <DisplayPrice details='inline'>{Price}</DisplayPrice>,
        'Created At (CET)': <DisplayDate>{CreatedAtCet}</DisplayDate>,
        'Settle At (CET)': <DisplayDate>{SettleAtCet}</DisplayDate>,
        'Payment Method': <DisplayPaymentMethod>{PaymentMethod}</DisplayPaymentMethod>,
        'Subscription Id': <DisplayGuid baseAnchor='/subscription'>{SubscriptionId}</DisplayGuid>,
        'Purchase Id': <DisplayGuid baseAnchor='/purchase'>{PurchaseId}</DisplayGuid>,
        'Status': <DisplayStatus mapping={transactionStatus}>{Status}</DisplayStatus>,
        'External Reference': <a href={adyenLink} target='_blank' rel='noopener noreferrer'>{ExternalReference}</a>,
        'External Reference Original':
  <a
    href={adyenLink}
    target='_blank'
    rel='noopener noreferrer'
  >
    {ExternalReferenceOriginal}
  </a>,
        'Error Text': ErrorText ?? 'None'
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            {
              isConfirmingCancellation ? (
                // TODO: extract modal
                <AriaModal
                  titleText='Edit Field'
                  mounted
                  verticallyCenter={false}
                  focusDialog
                  getApplicationNode={() => document.getElementById('app')}
                  dialogClass='dialog-size-normal'
                  scrollDisabled
                >
                  <h3>Are you sure you want to proceed?</h3>
                  <p>
                    This refunds the whole purchase this transaction belongs to and marks the purchase
                    and its products Refunded. It is refused while a signup of the purchase is still
                    booked: use the signup&apos;s force cancellation instead, which cancels and refunds.
                  </p>

                  <ButtonOBSOLETED
                    buttonColor='danger'
                    size='small'
                    onClick={async () => {
                      const {
                        api: {
                          transactions: {
                            cancelTransaction,
                            getTransaction
                          }
                        }
                      } = this.props;

                      this.setState({
                        isConfirmingCancellation: false,
                        transactionData: null
                      });

                      try {
                        await cancelTransaction(transactionId);
                      }
                      catch (e) {
                        this.setState({
                          errorMessage: new Message('error', `Unable to cancel transaction: ${e}`)
                        });
                      }

                      const newTransactionData = await getTransaction(transactionId);

                      this.setState({
                        isConfirmingCancellation: false,
                        transactionData: newTransactionData
                      });
                    }}
                    disabled={false}
                    buttonContent='Cancel Transaction'
                    ariaLabel='cancel transaction'
                  >
                    Proceed
                  </ButtonOBSOLETED>
                  <br />
                  <ButtonOBSOLETED
                    buttonColor='gray'
                    size='small'
                    onClick={() => {
                      this.setState({ isConfirmingCancellation: false });
                    }}
                    disabled={false}
                    buttonContent='Back'
                    ariaLabel='cancel transaction'
                  >
                    Back
                  </ButtonOBSOLETED>
                </AriaModal>
              ) : ''
            }
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Transaction details'
                documentDescription='Transaction details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Transaction
              </h2>
              <h5 className='main-page-subheader'>{transactionId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              {/* Subscription charges have no purchase; the backend refuses them
                  (use the subscription's regret or force termination). */}
              {transactionData && transactionData.PurchaseId ? (
                <Action action={() => {
                  this.setState({ isConfirmingCancellation: true });
                }}
                >
                  Cancel
                </Action>
              ) : <NoLink>None</NoLink>}
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Transaction = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(TransactionInternal)));

Transaction.requiresLogin = true;
Transaction.propTypes = { isLoggedIn: PropTypes.bool };

export default Transaction;
